import 'core-js'
import feathers from 'feathers-client/dist/feathers'
import socketio from 'feathers-socketio/client'
import io from 'socket.io-client'
// import rx from 'feathers-reactive'
// import RxJs from 'rxjs'

const socket = io('https://booking.meine-insel.at')

const app = feathers()
  .configure(socketio(socket, {
    timeout: 15000
  }))
  .configure(feathers.hooks())
  // .configure(rx(RxJs))
  .configure(feathers.authentication({ storage: window.localStorage }))

export default app

export const bookingService = app.service('bookings')
export const boatService = app.service('boats')
export const reservationService = app.service('reservations')
export const settingService = app.service('settings')
export const sessionService = app.service('sessions')
export const userService = app.service('users')
export const reasonService = app.service('reasons')
export const voucherService = app.service('vouchers')
export const additonalServiceService = app.service('additionalServices')
export const dailyReportService = app.service('dailyReports')

export const auth = app.authentication

// in  actions.js, your component and anywhere else you need your services:
// import messageService from './services';

// or load all services at once: import * as services from './services'
// and access them as services.messageService etc.

app.io.on('reconnect', arg => {
  console.log('reconnected')
  app.authenticate({}).then(() => {
    console.log('reauthenticated')
  }).catch(error => {
    console.error('auth failed', error)
  })
})


// WEBPACK FOOTER //
// ./src/services/index.js